import AdminEmployeeTable from "../../components/Admin/AdminEmployee";

function AdminEmployee() {
  return <AdminEmployeeTable></AdminEmployeeTable>;
}

export default AdminEmployee;
